module.exports = __webpack_public_path__ + "media/images/icons/rotate-ccw-2103fcaf288a8e3c7fda055a8a0ac54c.svg";